import axiosInstance from "./axios.instance";

export const layDanhSachKhungGiaDat = async (
  pageIndex: number = 1,
  pageSize: number = 20
) => {
  return axiosInstance.get(
    `KhungGiaDat?pageIndex=${pageIndex}&pageSize=${pageSize}`
  );
};

export const themMoiKhungGiaDat = async (body: any[]) => {
  return axiosInstance.post(`KhungGiaDat`, body);
};

export const layKhungGiaDatMetadataApi = async () => {
  return axiosInstance.get(`KhungGiaDat/metadata`) as any;
};

export const chuyenLichSuApi = async (
  nam: number,
  type: "BGD" | "HSDC" | "KGD"
) => {
  let url = "";
  switch (type) {
    case "BGD": {
      url = "/BangGiaDat/lichsu";
      break;
    }
    case "HSDC": {
      url = "/HeSoDieuChinh/lichsu";
      break;
    }
    default: {
      url = "/KhungGiaDat/lichsu";
      break;
    }
  }
  return axiosInstance.post(`${url}?year=${nam}`);
};
